import { render, staticRenderFns } from "./LoginDealRefund.vue?vue&type=template&id=797fa724&scoped=true&"
import script from "./LoginDealRefund.vue?vue&type=script&lang=js&"
export * from "./LoginDealRefund.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealRefund.vue?vue&type=style&index=0&id=797fa724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fa724",
  null
  
)

export default component.exports